import React from 'react'
import { connect } from 'react-redux'
import AdminsTab from '../components/admins-tab'

const mapStateToProps = (state) => ({
  ...state.adminsTab
})

export default connect(mapStateToProps)(AdminsTab)
